<template>
    <div class="Information">
        <h2>Information</h2>
        <form @submit="SubmitRecord">
            <div class="row">
                <div class="col">
                    <div class="record-section">
                        <h4>Employee Identity</h4>
                        <div class="form-group">
                            <label>First Name:</label>
                            <input type="text" v-model="TargetRecord.FirstName" required class="form-control" />
                        </div>
                        <div class="form-group">
                            <label>Last Name:</label>
                            <input type="text" v-model="TargetRecord.LastName" required class="form-control" />
                        </div>
                        <div class="form-group">
                            <label>Email:</label>
                            <p>{{Record.Email}}</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="record-section">
                        <h4>Third Party Systems</h4>
                        <div class="form-group">
                            <label>Avatar Provider Name:</label>
                            <input type="text" v-model="TargetRecord.AvatarProviderName" class="form-control" />
                        </div>
                        <div class="form-group">
                            <label>Previous Avatar Provider Names (Separated by Pipe | ):</label>
                            <input type="text" v-model="TargetRecord.PreviousAvatarProviderNames" class="form-control" />
                        </div>
                        <div class="form-group">
                            <label>San Bernardino Provider ID:</label>
                            <input type="text" v-model="TargetRecord.SanBernardinoProviderID" class="form-control" />
                        </div>
                        <div class="form-group">
                            <label>Welligent Provider ID:</label>
                            <input type="text" v-model="TargetRecord.WelligentID" class="form-control" />
                        </div>
                        <div>
                            <label>Primary Default Specifier:</label>
                            <select class="form-control" v-model="TargetRecord.PrimaryDefaultSpecifier">
                                <option :value="null">NONE</option>
                                <option value="MH PRIMARY">MH PRIMARY</option>
                            </select>
                        </div>

                    </div>
                </div>
                <div class="col">
                    <div class="record-section">
                        <h4>Professional Details</h4>
                        <div class="form-group">
                            <label>License Number:</label>
                            <input class="form-control" v-model="TargetRecord.LicenseNumber" />
                        </div>
                        <div class="form-group">
                            <label>License Type:</label>
                            <select class="form-control" v-model="TargetRecord.LicenseType">
                                <option value="">NON-LICENSED</option>
                                <option value="AMFT">AMFT</option>
                                <option value="ASW">ASW</option>
                                <option value="APCC">APCC</option>
                                <option value="LPCC">LPCC</option>
                                <option value="LCSW">LCSW</option>
                                <option value="LMFT">LMFT</option>
                                <option value="Ph.D.">Ph.D.</option>
                                <option value="M.D.">M.D.</option>
                                <option value="MFT Trainee">MFT Trainee</option>
                                <option value="MFT Intern">MSW Intern</option>
                                <option value="PCC Tainee">PCC Trainee</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Professional Title:</label>
                            <select class="form-control" v-model="TargetRecord.ProfessionalTitle">
                                <option value=""></option>
                                <option value="Registered Associate Marriage and Family Therapist">Registered Associate Marriage and Family Therapist</option>
                                <option value="Registered Associate Clinical Social Worker">Registered Associate Clinical Social Worker</option>
                                <option value="Registered Associate Professional Clinical Counselor">Registered Associate Professional Clinical Counselor</option>
                                <option value="Licensed Professional Clinical Counselor">Licensed Professional Clinical Counselor</option>
                                <option value="Licensed Clinical Social Worker">Licensed Clinical Social Worker</option>
                                <option value="Licensed Marriage and Family Therapist">Licensed Marriage and Family Therapist</option>
                                <option value="Licensed Psychiatrist">Licensed Psychiatrist</option>
                                <option value="MFT Trainee">Marriage and Family Therapist Trainee</option>
                                <option value="MFT Intern">Master of Social Work Intern</option>
                                <option value="PCC Tainee">Professional Clinical Counselor Trainee</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-top:20px;">
                <div class="col">
                    <button type="submit" class="form-control btn btn-success">SAVE CHANGES</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import { EventBus } from '../../../../services/event-bus.js';
    //import icons


    //mixins

    export default {
        name: "ProviderInformation",
        props: [
            "Record"
        ],
        data: function () {
            return {
                TableData: [],
                TargetRecord: {},
                
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                },
            };
        },
        methods: {

            //////////////////////////
            //  API CONNECTIONS
            //////////////////////////

            //Save Record
            SubmitRecord(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("PUT", "MentalHealth/Billing/ProviderProfile", this.TargetRecord, this.SubmitRecordSuccess, () => { }, true);
            },
            SubmitRecordSuccess(response) {
                EventBus.$emit('profile-update-needed', this.Record.Id);
                this.TargetRecord = response.data.data;
                alert("RECORD HAS BEEN UPDATED");
            },

            //////////////////////////
            //  MISC METHODS
            //////////////////////////
            formatDate(value, fmt = 'MM/DD/YY', defaultVal = '') {
                return (value == null)
                    ? defaultVal
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            }
        },
        components: {
            flatPickr
        },
        computed: {

        },
        mounted() {
            this.TargetRecord = JSON.parse(JSON.stringify(this.Record));
        }
    }
</script>